import "@babel/polyfill";
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
import { ValidationProvider, ValidationObserver, extend, localize } from "vee-validate";
import ja from "@/assets/ja.json";
import "vue2-timepicker/dist/VueTimepicker.css";
import { required, email, integer } from "vee-validate/dist/rules";
import Datepicker from "vuejs-datepicker";
import VueTimepicker from "vue2-timepicker";
import VModal from "vue-js-modal";
import VueAnalytics from "vue-analytics";
import App from "./App.vue";
import router from "./router";
import store from "./store";

localize("ja", ja);
Vue.component("ValidationProcider", ValidationProvider);
extend("required", required);
extend("integer", integer);
extend("email", email);
extend("confirm", {
  params: [{ name: "target" }],
  validate(value, params) {
    if ("target" in params) {
      return value === params.target;
    }
    return false;
  },
  message: "確認内容が一致していません",
});
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.use(VueGoogleMaps, {
  load: {
    // key: "AIzaSyDVBchRXp5dfpTFRACY1ny1xHQFXNoFs1c",
    key: "AIzaSyCga5qsUCHw6RjJCDSImoDZ0iCGVwJ5tGg",
    libraries: "places",
  },
});
Vue.use(VueAnalytics, {
  id: "UA-162883910-2",
  router,
});

require("@/assets/styles/index.sass");

Vue.component("Datepicker", Datepicker);
Vue.component("VueTimepicker", VueTimepicker);

Vue.use(VModal, { componentName: "VModal" });

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");
